module.exports = __webpack_public_path__ + "static/media/link.e39607cf.svg";